const selectArrayToInteger = (_data,key) =>{
    let _value = 0;
    if(_data.length > 0){_value = _data[0][key];}
    return parseInt(_value);
};
export default selectArrayToInteger;